const contactInfo = {
    phones: [
        { number: '+1 201-682-7121', label: 'US' },
        { number: '+91 98250 00681', label: 'India' }
    ],
    emails: [
        'simplitechs.info@gmail.com',
    ],
    // address: {
    //     lines:{}
    // },
    businessHours: [
        'Mon - Fri: 9:00 AM - 6:00 PM',
        'Sat: 10:00 AM - 4:00 PM'
    ],
    social: {
        facebook: '#',
        twitter: '#',
        linkedin: '#',
        instagram: '#'
    }
};

export default contactInfo;
